import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Heart } from 'lucide-react';
import Navigation from './Navigation';

const ContactPage = ({ onCartOpen }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const subject = formData.get('subject');
    const message = formData.get('message');
    const mailtoLink = `mailto:nenamiamibiz@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="min-h-screen bg-[#F5EFE4] text-[#3D2817]">
      <Navigation onCartOpen={onCartOpen} />

      {/* Header */}
      <header className="pt-32 pb-12 text-center px-6">
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-4">Contact us</h1>
        <div className="flex items-center justify-center gap-3 text-[#6B7C3F] mb-4">
          <span className="h-px w-12 bg-[#6B7C3F]/40" />
          <Heart className="w-4 h-4 fill-current" />
          <span className="h-px w-12 bg-[#6B7C3F]/40" />
        </div>
        <p className="font-serif italic text-xl text-[#6B7C3F] max-w-xl mx-auto">
          Let us help you create something special
        </p>
      </header>

      <main className="max-w-6xl mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16">
          {/* Form */}
          <div className="bg-[#FAF6EE] p-8 md:p-10 border border-[#E5DCC9]">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="subject" className="block text-xs tracking-[0.2em] uppercase mb-2 text-[#3D2817]">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-3 bg-white border border-[#E5DCC9] focus:outline-none focus:border-[#6B7C3F] text-[#3D2817] placeholder-[#6B5644]/50"
                  placeholder="What's this about?"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-xs tracking-[0.2em] uppercase mb-2 text-[#3D2817]">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="6"
                  className="w-full px-4 py-3 bg-white border border-[#E5DCC9] focus:outline-none focus:border-[#6B7C3F] text-[#3D2817] placeholder-[#6B5644]/50"
                  placeholder="Tell us what you'd like to order..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#6B7C3F] text-[#FAF6EE] py-4 hover:bg-[#5A6A35] transition-colors flex items-center justify-center gap-2 tracking-[0.2em] uppercase text-sm"
              >
                <Mail className="w-4 h-4" />
                Send Message
              </button>
            </form>
          </div>

          {/* Info */}
          <div className="space-y-6">
            <div className="bg-[#FAF6EE] p-8 md:p-10 border border-[#E5DCC9]">
              <h2 className="font-serif text-2xl mb-6">Get in touch</h2>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <Mail className="w-5 h-5 text-[#6B7C3F] mt-1 flex-shrink-0" strokeWidth={1.5} />
                  <div>
                    <p className="text-xs tracking-[0.2em] uppercase text-[#6B5644]">Email us</p>
                    <a
                      href="mailto:nenamiamibiz@gmail.com"
                      className="text-[#3D2817] hover:text-[#6B7C3F] transition-colors"
                    >
                      nenamiamibiz@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <MapPin className="w-5 h-5 text-[#6B7C3F] mt-1 flex-shrink-0" strokeWidth={1.5} />
                  <div>
                    <p className="text-xs tracking-[0.2em] uppercase text-[#6B5644]">Location</p>
                    <p className="text-[#3D2817]">Miami, Florida</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Instagram className="w-5 h-5 text-[#6B7C3F] mt-1 flex-shrink-0" strokeWidth={1.5} />
                  <div>
                    <p className="text-xs tracking-[0.2em] uppercase text-[#6B5644]">Follow us</p>
                    <a
                      href="https://www.instagram.com/nenamiami/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#3D2817] hover:text-[#6B7C3F] transition-colors"
                    >
                      @nenamiami
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#FAF6EE] p-8 md:p-10 border border-[#E5DCC9]">
              <h3 className="font-serif text-xl mb-3">Custom orders</h3>
              <p className="text-[#6B5644] leading-relaxed">
                Planning something special? We'd love to help create the perfect cake for your
                occasion. Contact us at least 48 hours in advance for custom orders.
              </p>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-[#6B7C3F] text-[#FAF6EE]">
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm tracking-[0.1em]">
          <p>© 2024 Nena Miami. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span>Miami, FL</span>
            <Link to="/contact" className="hover:opacity-80 transition-opacity uppercase">Contact</Link>
            <a
              href="https://instagram.com/nenamiami"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity uppercase"
            >
              Instagram
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
